// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/query.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Value } from "./value_pb.js";

/**
 * Supported types of comparison operators.
 *
 * @generated from enum ai.h2o.storage.Operator
 */
export const Operator = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.storage.Operator",
  [
    {no: 0, name: "OPERATOR_UNSPECIFIED"},
    {no: 1, name: "EQUAL_TO"},
    {no: 2, name: "NOT_EQUAL_TO"},
    {no: 3, name: "LESS_THAN"},
    {no: 4, name: "LESS_OR_EQUAL_TO"},
    {no: 5, name: "GREATER_THAN"},
    {no: 6, name: "GREATER_OR_EQUAL_TO"},
    {no: 7, name: "CONTAINS"},
  ],
);

/**
 * Types of inclusion constraints.
 *
 * @generated from enum ai.h2o.storage.Inclusion
 */
export const Inclusion = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.storage.Inclusion",
  [
    {no: 0, name: "INCLUDE"},
    {no: 1, name: "EXCLUDE"},
  ],
);

/**
 * Disjunction of multiple constraints.
 *
 * @generated from message ai.h2o.storage.Query
 */
export const Query = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.Query",
  () => [
    { no: 1, name: "clause", kind: "message", T: Clause, repeated: true },
  ],
);

/**
 * Conjunction of multiple constraints.
 * There is an implicit conjunction, AND, between all the constraints inside.
 *
 * @generated from message ai.h2o.storage.Clause
 */
export const Clause = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.Clause",
  () => [
    { no: 1, name: "property_constraint", kind: "message", T: PropertyConstraint, repeated: true },
    { no: 2, name: "tag_constraint", kind: "message", T: TagConstraint, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.PropertyConstraint
 */
export const PropertyConstraint = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.PropertyConstraint",
  () => [
    { no: 1, name: "property", kind: "message", T: Property },
    { no: 2, name: "operator", kind: "enum", T: proto3.getEnumType(Operator) },
    { no: 3, name: "value", kind: "message", T: Value },
  ],
);

/**
 * Specifies a property of an entity, i.e., direct field, metadata, or a metric
 * value.
 *
 * @generated from message ai.h2o.storage.Property
 */
export const Property = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.Property",
  () => [
    { no: 1, name: "field", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "property_type" },
    { no: 2, name: "metadata", kind: "message", T: MetadataReference, oneof: "property_type" },
    { no: 3, name: "metric", kind: "message", T: MetricReference, oneof: "property_type" },
  ],
);

/**
 * @generated from message ai.h2o.storage.MetadataReference
 */
export const MetadataReference = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.MetadataReference",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.MetricReference
 */
export const MetricReference = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.MetricReference",
  () => [
    { no: 1, name: "dataset_reference", kind: "enum", T: proto3.getEnumType(MetricReference_DatasetReference) },
    { no: 2, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum ai.h2o.storage.MetricReference.DatasetReference
 */
export const MetricReference_DatasetReference = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.storage.MetricReference.DatasetReference",
  [
    {no: 0, name: "DATASET_REFERENCE_UNSPECIFIED"},
    {no: 1, name: "TRAINING_DATASET"},
    {no: 2, name: "TESTING_DATASET"},
    {no: 3, name: "VALIDATION_DATASET"},
    {no: 4, name: "CUSTOM_DATASET"},
  ],
);

/**
 * Specifies a constraint for a single tag
 *
 * @generated from message ai.h2o.storage.TagConstraint
 */
export const TagConstraint = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.TagConstraint",
  () => [
    { no: 1, name: "tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "inclusion", kind: "enum", T: proto3.getEnumType(Inclusion) },
  ],
);

